export default "__VITE_ASSET__BJ4Tb_0v__"